import "../../../assets/scss/components/sections/home/features-2.scss";
import { Col, Container, Image, Row } from "react-bootstrap";

import graph from "../../../assets/images/home/graph.svg";
import Btn from "../../templates/button";
import Heading from "../../templates/heading";

import icon from "../../../assets/images/home/graph-clock-icon.svg";

const Features2 = () => {
  return (
    <div className="features-2-section">
      <Container>
        <div className="features-2">
          <Heading
            heading="Get Hired Faster with Resumly"
            text="Land more interviews by automating your job applications"
          />
          <div className="content">
            <Row className="align-items-center justify-space-between">
              <Col lg={5}>
                <div className="left-content">
                  <h3 className="heading-3">Get More Interviews</h3>
                  <p className="paragraph-small-regular">
                    Save time and achieve better results with our AI-powered
                    tailored resumes.
                  </p>
                  <div className="">
                    <Btn
                      text="Get started now"
                      class="btn-secondary"
                      handle={() => {
                        window.location.href =
                          process.env.REACT_APP_APP_REGISTER_URL;
                      }}
                    />
                  </div>
                </div>
              </Col>
              <Col lg={7}>
                <div className="right-content">
                  <div className="image">
                    <Image src={graph} />
                    <h5 className="heading-5">
                      <Image src={icon} />
                      Save Time & Energy
                    </h5>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Features2;
